<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div style="display: flex;justify-content: end;margin: 5px 0 20px 0;">
      <div [formGroup]="agregarForm" style="display: flex;">
        <input (change)="dateSelected()" class="form-control" formControlName="date" id="date" type="date">
      </div>
      <div (click)="previousDate()" class="btn btn-success" style="margin-left: 5px;">
        <i aria-hidden="true" class="fa fa-caret-left"></i> Fecha anterior
      </div>
      <div (click)="nextDate()" class="btn btn-success" style="margin-left: 5px;">
        Fecha siguiente <i aria-hidden="true" class="fa fa-caret-right"></i>
      </div>
      <div (click)="currentDate()" class="btn btn-success" style="margin-left: 5px;">
        <i aria-hidden="true" class="fa fa-caret-down"></i> Fecha actual
      </div>
    </div>
    <div style="float: right;text-align: end;">Fecha: {{ queryDate }}</div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                     [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>
